import React, { Component } from "react";

class Home extends Component {
  render() {
    return <div>Faça login para acessar o admin</div>;
  }
}

export default Home;
